import { useState, useEffect } from 'react';
import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext';
import Block from '../../../components/Block/Block';
import style from './samboprojectblock.module.scss';
import samboprojectbanner from '../../../assets/samboprojectbannertwo.png';

const SamboProjectBlock = () => {
    const { settings: { contrast, images } } = useAccessibility();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const StatBlock = ({ amount, object, defaultBg }) => {
        const bgColor = contrast !== 'default' ? 
            'var(--bg-primary)' : 
            defaultBg;
        
        const textColor = contrast !== 'default' ? 
            'var(--text-primary)' : 
            '#000';

        return (
            <div 
                className={style.stat}
                style={{
                    background: bgColor,
                    color: textColor,
                    width: isMobile ? '100%' : '20%',
                    margin: isMobile ? '0.5rem 0' : '0'
                }}
            >
                <span className={style.amount}>{amount}</span>
                <span className={style.object}>{object}</span>
            </div>
        );
    };

    const handleButtonClick = () => {
        window.open('https://ssambo.ru/', '_blank');
    };

    return (
   <Block
            flexDirection="column"
            width='75%'
            height='fit-content'
            justifyContent="center"
            alignItems="start"
            background={contrast !== 'default' ? 'var(--bg-primary)' : 'rgba(255, 255, 255, 0.85)'}
            header='               ВСЕРОССИЙСКИЙ ПРОЕКТ "САМБО В ШКОЛУ"'
        >
            <div className={style.content}>
                {images && (
                    <div className={style.banner}>
                        <img
                            className={style.samboprojectbanner}
                            src={samboprojectbanner}
                            alt='ПРОЕКТ "САМБО В ШКОЛУ"'
                            loading="lazy"
                        />
                    </div>
                )}
                <div className={style.wrapperStat}>
                    <StatBlock 
                        amount="89" 
                        object="РЕГИОНОВ РФ" 
                        defaultBg="linear-gradient(135deg, #ffffff, #ece1e1, #fcecec)"
                    />
                    <StatBlock 
                        amount="3 000" 
                        object="ШКОЛ В ПРОЕКТЕ" 
                        defaultBg="linear-gradient(135deg, #0032a0, #4488ff, #ffffff)"
                    />
                    <StatBlock 
                        amount="1 МЛН" 
                        object="УЧАСТНИКОВ" 
                        defaultBg="linear-gradient(135deg, #ff1100, #ff4f4f, #ffffff)"
                    />
                </div>
                <div className={style.wrapperButton}>
                    <button 
                        className={style.customButton}
                        onClick={handleButtonClick}
                    >
                        Узнать больше
                    </button>
                </div>
            </div>
        </Block>
    );
};

export default SamboProjectBlock;